import useApi from 'common/hooks/useApi';
import { isActionCompleteSuccess } from 'common/services/api/isActionCompleteSuccess';
import { ActionCompleteResponse } from 'common/types/ApiResponse';
import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import VerifyEmailPresenter from './VerifyEmailPresenter';
import ReactGA from 'react-ga4';

function parseParams(queryString: string) {
  const params = new URLSearchParams(queryString);
  const email = params.get('email') || '';
  const verifyId = params.get('verifyId') || '';
  return {
    email: decodeURIComponent(email),
    verifyId: decodeURIComponent(verifyId),
  };
}

function VerifyEmailContainer() {
  const { location, push } = useHistory();
  const { email, verifyId } = parseParams(location.search);
  const [, request] = useApi<ActionCompleteResponse>({
    url: '/register/verifyProfile',
    method: 'PUT',
    bypassTokenCheck: true,
  });

  useEffect(() => {
    let isSubscribed = true;

    const verify = async () => {
      const { data } = await request({
        email,
        verifyId,
      });
      if (isSubscribed && data && isActionCompleteSuccess(data)) {
        ReactGA.event({
          category: 'Application',
          action: 'Profile Email Verified',
        });
        push('/auth/login', { showVerifySuccess: true });
      }
    };

    if (email && verifyId) {
      verify();
    }

    return () => {
      isSubscribed = false;
    };
  }, [email, verifyId]);

  if (!(email && verifyId)) {
    // push('/error');
    return null;
  }

  return <VerifyEmailPresenter />;
}

export default VerifyEmailContainer;
